<template>
  <form action="https://bizmessage.kakao.com/chat/open" target="_self" method="post" ref="form">
    <input type="hidden" name="uuid" v-model="$route.query.plusFriendId" />
    <input type="hidden" name="extra" v-model="$route.query.extra" />
    <input type="hidden" name="bot" v-model="$route.query.bot" />
    <input type="hidden" name="event" v-model="$route.query.event" />
  </form>
</template>

<script>
export default {
  name: 'chatOpen',
  created() {
    window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
    this.$http({
      method: 'GET',
      url: '/api/external/brand/isPossibleCreateRoom',
      params: {
        plusFriendId: this.$route.query.plusFriendId,
        brandId: this.$route.query.brandId
      }
    })
      .then((result) => {
        if (result.data.code === 0) {
          this.$refs.form.submit();
        } else {
          alert(result.data.message);
        }
      })
      .catch(() => {
        alert('서버에 문제가 발생');
      });
  }
};
</script>
